/**
 * In-stock filter + sort submit for browse pages without full client catalog.
 */
(function () {
  if (
    document.getElementById("lb-collection-page") &&
    document.getElementById("lb-collection-page").getAttribute("data-lb-catalog") ===
      "true"
  ) {
    return;
  }

  var form = document.getElementById("lb-browse-filters");
  if (!form) return;

  var sortSelect = form.querySelector("[data-lb-sort-select]");
  var inStockInput = form.querySelector("[data-lb-instock-filter]");
  var clearBtn = form.querySelector("[data-lb-filter-clear]");
  var statusEl = document.getElementById("lb-filter-status");

  var grid =
    document.getElementById("lb-collection-grid") ||
    document.querySelector(".lb-product-grid");

  if (!grid) return;

  function gridItems() {
    var items = grid.querySelectorAll(":scope > .lb-product-grid__item");
    if (items.length) return Array.prototype.slice.call(items);
    items = grid.querySelectorAll(
      ":scope > [data-product-card], :scope > .lb-product-card"
    );
    return Array.prototype.slice.call(items);
  }

  function cardFromItem(item) {
    if (item.matches && item.matches("[data-product-card], .lb-product-card")) {
      return item;
    }
    return item.querySelector("[data-product-card], .lb-product-card") || item;
  }

  function cardMeta(card) {
    return {
      available: card.getAttribute("data-product-available") === "true",
    };
  }

  function applyFilters() {
    var inStockOnly = inStockInput && inStockInput.checked;
    var shown = 0;
    var items = gridItems();

    items.forEach(function (item) {
      var meta = cardMeta(cardFromItem(item));
      var ok = !inStockOnly || meta.available;
      item.style.display = ok ? "" : "none";
      if (ok) shown += 1;
    });

    if (statusEl) {
      if (inStockOnly) {
        statusEl.hidden = false;
        statusEl.textContent =
          shown + " of " + items.length + " on this page are in stock.";
      } else {
        statusEl.hidden = true;
      }
    }

    if (clearBtn) {
      clearBtn.hidden = !(inStockInput && inStockInput.checked);
    }
  }

  if (sortSelect) {
    sortSelect.addEventListener("change", function () {
      form.requestSubmit();
    });
  }

  if (inStockInput) {
    inStockInput.addEventListener("change", applyFilters);
  }

  if (clearBtn) {
    clearBtn.addEventListener("click", function () {
      if (inStockInput) inStockInput.checked = false;
      applyFilters();
    });
  }

  applyFilters();
})();
